import { render, staticRenderFns } from "./FoldersArchived.vue?vue&type=template&id=0c069acd"
import script from "./FoldersArchived.vue?vue&type=script&lang=js"
export * from "./FoldersArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports